(function(){
  "use strict";
  function onReady(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function killCartNoise(){
    document.querySelectorAll('.nm-cart-revenue-box,.nm-cart-reco,.nm-cart-drawer__upsells,[class*="cart-upsell"],[data-upsell],.nm-cross-sell-links,.nm-stack-links').forEach(function(el){ el.remove(); });
  }

  function polishFooter(){
    var footer = document.querySelector('.site-footer');
    if(!footer) return;
    footer.querySelectorAll('a').forEach(function(a){
      if((a.textContent||'').trim() === 'Subscribe') a.textContent = 'Suscribirme';
    });
  }

  function trimCollectionClutter(){
    document.querySelectorAll('.nm-stacks-strip,.nm-collection-sticky,.nm-cross-sell-links').forEach(function(el){ el.remove(); });
  }

  onReady(function(){
    killCartNoise();
    polishFooter();
    trimCollectionClutter();
    var mo = new MutationObserver(function(){
      killCartNoise();
      polishFooter();
      trimCollectionClutter();
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  });
})();
